export const APP_CORE_STATE_KEYS = {
  dashboardPreferences: "app_core_state_dashboard_preferences",
} as const;
